// import {FC} from 'react'

// const AppointmentTypeCell = (props: any) => {
//   return (
//     <div className='d-flex ms-5 '>
//       <span className='text-black fw-bold fs-7 '>{props?.tableProps?.appointmentType}</span>
//     </div>
//   )
// }

// export {AppointmentTypeCell}

/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {MenuComponent} from '../../../../../../../../_ePulse/assets/ts/components'
import {KTSVG} from '../../../../../../../../_ePulse/helpers'
import {Link, useNavigate} from 'react-router-dom'

import {checkPermission} from '../../../../../../../App'
import useLocalStorageFetch from '../../../../../../../../hooks/localStorageFetch'
import {useDispatch} from 'react-redux'
import {actionsUsers} from '../../../../../../../../setup/redux/rootReducer'

const AppointmentTypeCell = (props: any) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const {role} = useLocalStorageFetch()

  const onHandleclick = (appointment: any) => {
    // navigate(`/${role}/rx_template/rx-on-fly`, {
    //   state: {
    //     appointmentId: appointment.id,
    //     patientData: {
    //       userId: appointment.patientId,
    //       firstName: appointment.firstName,
    //       lastName: appointment.lastName,
    //     },
    //   },
    // })

    //New user flow
    navigate(`/${role}/patient-details`, {
      state: {
        appointmentId: appointment.id,
        patientData: {
          userId: appointment.patientId,
          firstName: appointment.firstName,
          lastName: appointment.lastName,
          profilePhoto: appointment.profilePhoto,
          dob: appointment.dob,
          mobileNumber: appointment.mobileNumber,
          age: appointment?.age,
        },
      },
    })
  }

  const appointment = props.tableProps

  return (
    <div className='d-flex ms-5'>
      <div className='d-flex flex-row col '>
        <div className='d-flex flex-row align-items-center '>
          {!appointment.isPrescriptionSent ? (
            checkPermission('storeClinicRxPrescriptionData') && (
              <button
                onClick={() => {
                  dispatch(actionsUsers.updateSelectedPatient({}))
                  onHandleclick(appointment)
                  localStorage.setItem('todayRXEdit', 'NO')
                }}
                className='menu-link text-dark border-0 bg-white'
              >
                <span className='text-black fw-bold fs-7 '>
                  {props?.tableProps?.appointmentType}
                </span>
              </button>
            )
          ) : (
            <span className='text-black fw-bold fs-7 '>{props?.tableProps?.appointmentType}</span>
          )}
        </div>
      </div>
    </div>
  )
}

export {AppointmentTypeCell}
